import { createContext, useContext, useEffect, useState } from "react";
import { getCurrentStaff, logoutStaff } from "../api/staffAuthApi";

const StaffAuthContext = createContext();

export const StaffAuthProvider = ({ children }) => {
  const [staff, setStaff] = useState(null);
  const [computed, setComputed] = useState({
    isClassTeacher: false,
    classTeacherSections: [],
  });
  const [loading, setLoading] = useState(true);

  const fetchStaff = async () => {
    try {
      const data = await getCurrentStaff();
      const staffData = data?.staff || data;

      setStaff(staffData);
      setComputed({
        isClassTeacher: data?.computed?.isClassTeacher || false,
        classTeacherSections: data?.computed?.classTeacherSections || [],
      });

      return staffData;
    } catch (error) {
      setStaff(null);
      setComputed({ isClassTeacher: false, classTeacherSections: [] });
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStaff();
  }, []);

  const logout = async () => {
    try {
      await logoutStaff();
    } catch (error) {}
    setStaff(null);
    setComputed({ isClassTeacher: false, classTeacherSections: [] });
  };

  const isPrincipal = () => {
    if (!staff) return false;
    return (
      staff?.roleId?.isPrincipal === true ||
      staff?.roleId?.name?.toLowerCase() === "principal" ||
      staff?.roleId?.code?.toLowerCase() === "principal"
    );
  };

  const hasModule = (moduleCode) => {
    if (isPrincipal()) return true;
    if (!staff?.roleId?.modules) return false;
    return staff.roleId.modules.some((module) => module.code === moduleCode);
  };

  const hasPermission = (permissionKey) => {
    if (isPrincipal()) return true;
    if (!staff?.roleId?.permissions) return false;
    return staff.roleId.permissions.some((p) => p.key === permissionKey);
  };

  return (
    <StaffAuthContext.Provider
      value={{
        staff,
        loading,
        logout,
        refreshStaff: fetchStaff,
        isAuthenticated: !!staff,
        isPrincipal: isPrincipal(),
        hasModule,
        hasPermission,
        isClassTeacher: computed.isClassTeacher,
        classTeacherSections: computed.classTeacherSections,
      }}
    >
      {children}
    </StaffAuthContext.Provider>
  );
};

export const useStaffAuth = () => useContext(StaffAuthContext);